import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pollution_layer_station = _resolveComponent("pollution-layer-station")!
  const _component_MapboxMarker = _resolveComponent("MapboxMarker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (station) => {
      return (_openBlock(), _createBlock(_component_MapboxMarker, {
        key: station.id,
        ref_for: true,
        ref: station.id,
        "lng-lat": _ctx.latLng(station),
        map: _ctx.map,
        selected: _ctx.currentStation?.id === station.id
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pollution_layer_station, {
            station: station,
            selected: _ctx.currentStation && _ctx.currentStation.id === station.id,
            "onClick:station": ({ marker }) => _ctx.$emit('select:station', { station, marker })
          }, null, 8 /* PROPS */, ["station", "selected", "onClick:station"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["lng-lat", "map", "selected"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}